import styled from "styled-components";

export const customStyles = {
  overlay: {
    backgroundColor: "#00000170",
  },
  content: {
    border: "none",
    background: "none",
    padding: "0",
  },
};
export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const CloseButton = styled.button`
  position: absolute;
  top: calc(var(--u) * 10);
  right: calc(var(--u) * 10);
  background: none;
  border: none;
  font-size: calc(var(--u) * 50);
  color: #ccc;
  cursor: pointer;
`;
export const ModalContent = styled.div`
  display: flex;
  height: 70%;
  width: 80%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;
`;
export const ModalHeader = styled.div<{ color: string }>`
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: ${(props) => props.color};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;
export const Logo = styled.img`
  position: absolute;
  left: calc(var(--u) * 10);
  width: calc(var(--u) * 75);
  height: calc(var(--u) * 75);
`;
export const ModalTitle = styled.h1`
  width: 100%;
  font-size: var(--fs-2xl);
  font-weight: bold;
  text-align: center;
  margin-top: var(--sp-10);
`;
export const ModalDescription = styled.p`
  width: 100%;
  font-size: var(--fs-base);
  text-align: center;
  margin-bottom: var(--sp-20);
`;
export const ModalBody = styled.div`
  width: 100%;
  height: 70%;
  background-color: #c0cdfd;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

export const Divider = styled.div`
  width: 1.5px;
  height: 100%;
  background-color: #000;
`;

export const TableWrapper = styled.div`
  width: 50%;
  height: 100%;
  display: grid;
  overflow-y: auto; /* Adicionado para permitir rolagem vertical independente */
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  grid-template-rows: auto 1fr;
`;

export const TableHeader = styled.th`
  border: 1px solid #ddd;
  text-align: center;
  background-color: #f2f2f2;
  position: sticky;
  top: 0;
`;

export const TableBody = styled.tbody`
  grid-area: 1 / 1;
`;

export const TableFooter = styled.tfoot`
  background-color: #f2f2f2;
  border-top: 1.5px solid #444;
  border-bottom: 1.5px solid #444;
  text-align: center;
  font-weight: bold;
  grid-area: 2 / 1;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
  height: calc(var(--u) * 32);
`;

export const TableRowRemoveButton = styled.button`
  margin-left: 50%;
  background-color: #ff4d4d;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #ff6666;
  }
  
`;

export const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: var(--sp-8);
  line-height: 1.5; /* Ajuste a linha conforme necessário */
`;

export const TableFooterRow = styled.tr``;

export const TableFooterCell = styled.td`
  font-weight: bold;
  line-height: 1.5; /* Ajuste a linha conforme necessário */
`;


export const RowContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-items: center;
  position: relative;
  margin-left: 15%;
`;
export const NumberInput = styled.div<{ color: string }>`
  width: calc(var(--u) * 150);
  font-size: var(--fs-base);
  position: relative;
  border: 1.5px solid ${(props) => props.color};
  border-radius: 6px;
  input {
    width: 100%;
    font-size: var(--fs-base);
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    border: 1.5px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;
  }

  input:focus {
    box-shadow: 0 0 0 1px #e8e8e8, 0 0 0 3px ${(props) => props.color};
  }

  label {
    transition: all 0.1s ease-in-out;
    color: #2c2c54;
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 10);
    transform: translateY(-50%);
    pointer-events: none;
    background: white;
    padding: 0 var(--sp-5);
    border-radius: 5px;
  }

  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    left: 0px;
    transform: scale(0.85) translateY(-120%);
    background: ${(props) => props.color};
    color: white;
  }
`;
export const Unit = styled.span<{ color: string }>`
  position: relative;
  font-size: var(--fs-base);
  opacity: 0.8;
  color: ${(props) => props.color};
  font-weight: bold;
  right: 45%;
`;
export const Button = styled.button<{ opacity: string }>`
  width: fit-content;
  height: calc(var(--u) * 40);
  background-color: white;
  opacity: ${(props) => props.opacity};
  color: black;
  border: none;
  border-radius: 12px;
  font-size: var(--fs-xl);
  font-weight: bold;
  cursor: pointer;
  padding: 0 var(--sp-20);
  margin: var(--sp-10);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:hover {
    opacity: 1;
  }
`;
export const ModalFooter = styled.div<{ color: string }>`
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: space-between; // Change this from center to space-between
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: ${(props) => props.color};
`;
